var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoursesIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "online-course 1",
    clipPath: "url(#clip0_605_4791)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.35742 16.0072H97.5553V81.5385H4.35742V16.0072Z",
    fill: "#ECF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M49.5 16.0072H97.5553V81.5385H49.5V16.0072Z",
    fill: "#D5E7FD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M69.887 81.5385V93.1873C69.887 94.7906 66.8555 94.6223 64.9838 94.6223L32.7382 94.5895C30.8664 94.5895 29.1128 94.7906 29.1128 93.1873V81.5385C29.1128 79.9352 30.6279 78.6375 32.4997 78.6375H66.5001C68.3718 78.6375 69.887 79.9352 69.887 81.5385Z",
    fill: "#3F558F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M69.8872 81.5385V93.1873C69.8872 94.7906 68.3161 94.9515 66.4444 94.9515L49.5 95.2807V78.6375H66.5003C68.372 78.6375 69.8872 79.9352 69.8872 81.5385Z",
    fill: "#1C3470"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M81.5259 93.1872C81.5259 94.7905 80.2262 96.0883 78.6248 96.0883H20.3752C18.7738 96.0883 17.4741 94.7905 17.4741 93.1872C17.4741 91.5858 18.7738 90.2861 20.3752 90.2861H49.5L71.9473 92.285C73.5487 92.285 81.5259 91.5858 81.5259 93.1872Z",
    fill: "#5A729E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M81.5259 93.1872C81.5259 94.7905 80.2262 96.0883 78.6248 96.0883H49.5V90.2861H78.6248C80.2262 90.2861 81.5259 91.5858 81.5259 93.1872Z",
    fill: "#3F558F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M99 16.0071V81.5385C99 83.1399 97.7003 84.4395 96.0989 84.4395H2.90107C1.29968 84.4395 0 83.1399 0 81.5385V16.0071C0 14.4038 1.29968 13.1061 2.90107 13.1061H20.3752C21.9766 13.1061 23.2763 14.4038 23.2763 16.0071C23.2763 17.6085 21.9766 18.9082 20.3752 18.9082H5.80214V78.6374H93.1979V18.9082H80.0812C78.4798 18.9082 77.1801 17.6085 77.1801 16.0071C77.1801 14.4038 78.4798 13.1061 80.0812 13.1061H96.0989C97.7003 13.1061 99 14.4038 99 16.0071Z",
    fill: "#5A729E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M99 16.0071V81.5385C99 83.1399 97.7003 84.4395 96.0989 84.4395H49.5V78.6374H93.1979V18.9082H80.0812C78.4798 18.9082 77.1801 17.6085 77.1801 16.0071C77.1801 14.4038 78.4798 13.1061 80.0812 13.1061H96.0989C97.7003 13.1061 99 14.4038 99 16.0071Z",
    fill: "#3F558F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M71.3315 19.8908V33.4813C71.3315 34.6824 70.5927 35.7577 69.471 36.189L49.5 43.6641C48.7289 43.6641 49.0227 43.6695 29.5271 36.189C28.4073 35.7577 27.6685 34.6824 27.6685 33.4813V19.5755C27.6685 17.9741 28.9681 16.6744 30.5695 16.6744C32.1709 16.6744 33.4706 17.9741 33.4706 19.5755C33.4706 19.6171 32.0382 19.5887 65.5313 19.8676C65.5429 18.2758 66.8368 16.9897 68.4304 16.9897C70.0318 16.9897 71.3315 18.2894 71.3315 19.8908Z",
    fill: "#5A729E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M71.3315 19.8907V33.4812C71.3315 34.6823 70.5927 35.7576 69.471 36.1889C50.0473 43.6694 50.2645 43.664 49.5 43.664V19.734L65.5313 19.8675C65.5429 18.2758 66.8368 16.9896 68.4305 16.9896C70.0318 16.9896 71.3315 18.2893 71.3315 19.8907Z",
    fill: "#3F558F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M82.9821 16.0072V36.394C82.9821 37.9973 81.6824 39.295 80.081 39.295C78.4796 39.295 77.18 37.9973 77.18 36.394L78.3996 17.8859L49.4999 29.1026C48.7918 29.1026 49.0843 29.1053 19.4177 18.7458C16.8329 17.8399 16.8327 14.1747 19.4177 13.2686C49.0473 2.90285 48.7914 2.91174 49.4999 2.91174L77.8399 14.4292C79.0254 14.8237 82.9821 14.7578 82.9821 16.0072Z",
    fill: "#3F558F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M82.9822 16.0072V36.394C82.9822 37.9973 81.6825 39.295 80.0811 39.295C78.4798 39.295 77.1801 37.9973 77.1801 36.394V20.0319C50.0967 29.1115 50.18 29.1026 49.5 29.1026V2.91174C50.1744 2.91174 49.859 2.91174 80.9979 13.255C82.1835 13.6496 82.9822 14.7578 82.9822 16.0072Z",
    fill: "#1C3470"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M26.2002 52.4247H14.5505C12.9483 52.4247 11.6494 53.7236 11.6494 55.3258V66.9755C11.6494 68.5776 12.9483 69.8766 14.5505 69.8766H26.2002C27.8024 69.8766 29.1013 68.5776 29.1013 66.9755V55.3258C29.1013 53.7236 27.8024 52.4247 26.2002 52.4247Z",
    fill: "#FC6284"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M87.3512 55.3264C87.3512 56.9278 86.0516 58.2274 84.4502 58.2274H37.8493C36.2479 58.2274 34.9482 56.9278 34.9482 55.3264C34.9482 53.723 36.2479 52.4253 37.8493 52.4253H84.4502C86.0516 52.4253 87.3512 53.723 87.3512 55.3264Z",
    fill: "#01C1F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M87.3512 66.9752C87.3512 68.5785 86.0516 69.8762 84.4502 69.8762H37.8493C36.2479 69.8762 34.9482 68.5785 34.9482 66.9752C34.9482 65.3738 36.2479 64.0741 37.8493 64.0741H84.4502C86.0516 64.0741 87.3512 65.3738 87.3512 66.9752Z",
    fill: "#01C1F0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M87.3512 66.9752C87.3512 68.5785 86.0516 69.8762 84.4502 69.8762H49.5V64.0741H84.4502C86.0516 64.0741 87.3512 65.3738 87.3512 66.9752Z",
    fill: "#00ADE9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M84.4502 58.2274H49.5V52.4253H84.4502C86.0516 52.4253 87.3512 53.723 87.3512 55.3264C87.3512 56.9278 86.0516 58.2274 84.4502 58.2274Z",
    fill: "#00ADE9"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_605_4791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 99,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoursesIcon);
export default __webpack_public_path__ + "static/media/CoursesIcon.266e4424776c53177f758eb85a71c963.svg";
export { ForwardRef as ReactComponent };